/**
 * Site-wide single source of truth for external links + brand constants
 * that previously lived as hardcoded string literals across multiple files.
 *
 * Edit the literal default below to change the Calendly URL site-wide.
 * Optionally override at deploy time without touching code by setting
 * `REACT_APP_CALENDLY_URL` in `frontend/.env` (preview) or in the deployed
 * environment. Code reads the env first and falls back to the default,
 * so removing the env var safely reverts to the literal.
 *
 * Any new external link / phone / social handle that gets referenced from
 * more than one place should live here, not as a fresh per-file constant.
 */

const _DEFAULT_CALENDLY_URL = 'https://calendly.com/vlewis-apex/30min';

export const CALENDLY_URL =
  (typeof process !== 'undefined' &&
    process.env &&
    process.env.REACT_APP_CALENDLY_URL) ||
  _DEFAULT_CALENDLY_URL;

// Brand logo + social — hoisted out of `MarketingSite.js` so the new audience /
// method / about pages can reuse the exact same asset without copy-pasting URLs.
export const LOGO_URL =
  'https://customer-assets.emergentagent.com/job_apex-athletes-mind/artifacts/ewmkb3wq_IMG_2112.JPG';

export const INSTAGRAM_URL = 'https://www.instagram.com/apexathleticmind/';

// Public verifiable credentials — keep filenames stable; static files live
// under /app/frontend/public/credentials/.
export const ELVTR_CERTIFICATE_URL = '/credentials/elvtr-sport-psychology-certificate.pdf';

